/* Lion's Mane & Cordyceps PDP (Lymphoria replica) — gallery, bundle tiers,
   purchase-mode toggle, cart, accordions, carousels, sticky bar.
   No Liquid here: money format + variant id arrive via data-attributes. */
(function(){
  var root = document.querySelector('[data-lm]');
  if(!root) return;

  /* ---- money -------------------------------------------------------- */
  var sample = root.dataset.moneySample || '$1.00';
  var sym = sample.replace(/[0-9.,\s]/g, '');
  var withDecimals = /[.,]\d\d/.test(sample);
  function money(cents){
    var n = cents / 100;
    return sym + (withDecimals ? n.toFixed(2) : String(Math.round(n)));
  }

  /* ---- bundle state -------------------------------------------------- */
  var unit = parseInt(root.dataset.unitCents, 10) || 0;   /* one bottle, cents */
  var variantId = root.dataset.variant;
  /* tier n: pay n bottles, receive qty[n]; "was" = receive-count at list price */
  var QTY  = {1:1, 2:3, 3:5};
  var tier = 2;                 /* default: Buy 2 Get 1 FREE (Most Popular) */
  var mode = 'one';             /* 'one' | 'sub' (subscribe = 25% off) */

  function priceFor(t){ var p = unit * t; return mode === 'sub' ? Math.round(p * 75 / 100) : p; }
  function wasFor(t){ return unit * QTY[t]; }

  var atcNow = root.querySelector('[data-lm-atc-now]');
  var atcWas = root.querySelector('[data-lm-atc-was]');

  function paint(){
    root.querySelectorAll('[data-lm-tier]').forEach(function(b){
      b.classList.toggle('is-on', parseInt(b.dataset.lmTier, 10) === tier);
    });
    root.querySelectorAll('[data-lm-mode]').forEach(function(b){
      b.classList.toggle('is-on', b.dataset.lmMode === mode);
    });
    atcNow.textContent = money(priceFor(tier));
    atcWas.textContent = money(wasFor(tier));
    atcWas.style.display = wasFor(tier) > priceFor(tier) ? '' : 'none';
  }

  root.querySelectorAll('[data-lm-tier]').forEach(function(b){
    b.addEventListener('click', function(){ tier = parseInt(b.dataset.lmTier, 10); paint(); });
  });
  root.querySelectorAll('[data-lm-mode]').forEach(function(b){
    b.addEventListener('click', function(){ mode = b.dataset.lmMode; paint(); });
  });

  /* ---- add to cart (bypasses app-injected forms) ---------------------- */
  function addToCart(){
    var btns = root.querySelectorAll('[data-lm-add]');
    btns.forEach(function(b){ b.disabled = true; });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: QTY[tier] })
    }).then(function(r){
      if(!r.ok) throw new Error('cart');
      window.themeGoToCheckout();
    }).catch(function(){
      btns.forEach(function(b){ b.disabled = false; });
      window.location.href = '/cart/add?id=' + variantId + '&quantity=' + QTY[tier];
    });
  }
  root.querySelectorAll('[data-lm-add]').forEach(function(b){
    b.addEventListener('click', addToCart);
  });

  /* ---- gallery -------------------------------------------------------- */
  var stage = root.querySelector('[data-lm-stage]');
  root.querySelectorAll('[data-lm-thumb]').forEach(function(t){
    t.addEventListener('click', function(){
      root.querySelectorAll('[data-lm-thumb]').forEach(function(o){ o.classList.remove('is-on'); });
      t.classList.add('is-on');
      if(stage && t.dataset.lmThumb) stage.src = t.dataset.lmThumb;
    });
  });

  /* ---- accordions (buy box + FAQ share the pattern) ------------------- */
  root.querySelectorAll('[data-lm-acc]').forEach(function(btn){
    btn.addEventListener('click', function(){
      btn.closest('[data-lm-acc-item]').classList.toggle('is-open');
    });
  });

  /* ---- carousels: arrows scroll one card, dots follow ------------------ */
  root.querySelectorAll('[data-lm-carousel]').forEach(function(wrap){
    var track = wrap.querySelector('.rev-lm__car');
    var dotsEl = wrap.querySelector('.rev-lm__dots');
    var cards = track.children.length;
    function step(){ var c = track.children[0]; return c ? c.offsetWidth + 26 : 320; }
    function visible(){ return Math.max(1, Math.round((track.clientWidth + 26) / step())); }
    function pages(){ return Math.max(1, cards - visible() + 1); }
    function page(){ return Math.min(pages() - 1, Math.round(track.scrollLeft / step())); }
    function dots(){
      var n = pages(), cur = page(), html = '';
      for(var i = 0; i < n; i++) html += '<i' + (i === cur ? ' class="is-on"' : '') + '></i>';
      dotsEl.innerHTML = html;
    }
    wrap.querySelector('[data-lm-prev]').addEventListener('click', function(){
      track.scrollBy({left: -step(), behavior: 'smooth'});
    });
    wrap.querySelector('[data-lm-next]').addEventListener('click', function(){
      track.scrollBy({left: step(), behavior: 'smooth'});
    });
    var t;
    track.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(dots, 80); }, {passive: true});
    window.addEventListener('resize', dots);
    dots();
  });

  /* ---- sticky bar ------------------------------------------------------ */
  var sticky = root.querySelector('[data-lm-sticky]');
  var hero = root.querySelector('[data-lm-hero]');
  if(sticky && hero){
    /* in theme preview, Shopify's bottom bar (#PBarNextFrameWrapper) would cover us */
    var pbar = document.getElementById('PBarNextFrameWrapper');
    if(pbar) sticky.style.bottom = pbar.getBoundingClientRect().height + 'px';
    function onScroll(){
      var past = hero.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-on', past);
    }
    window.addEventListener('scroll', onScroll, {passive: true});
    onScroll();
    sticky.querySelector('[data-lm-top]').addEventListener('click', function(){
      hero.scrollIntoView({behavior: 'smooth'});
    });
  }

  paint();
})();
